import { useSize } from 'ahooks';
import { Button, Ellipsis, Modal, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import img from 'app/img';
import { useI18n } from 'i18n/useI18n';
import QRCode, { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import { useEffect, useRef, useState } from 'react';
import { AiFillCloseCircle, AiOutlineClose } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserDataType } from 'services/apis/sys/user-api';
import { UserGroupDataType } from 'services/apis/usr/user-group-api';
import { getItemWithExpiration, removeItem } from 'utils/localStorageUtil';
import RoundImg from '../img/round-img';
import UserLoginCertificate from './userLoginCertificate';

export type UserInfoDataType = {
  avatar: string;
  username: string;
  usergroupName: string;
  usergroupRemainTime: string;
};

const UserInfo: React.FC<UserInfoDataType> = (props) => {
  const { t } = useI18n();
  // const userLevelMap: Map<string, UserGroupDataType> = new Map();
  const navigate = useNavigate();

  useEffect(() => {
    // props.userGroupList.forEach((item) => userLevelMap.set(item?.uuid as string, item));
  }, []);

  const modalRef = useRef(null);
  const modalRefSize = useSize(modalRef);
  const [loginCertificateVisible, toggleLoginCertificateVisible] = useState(false);

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        className=" mx-2"
      >
        <RoundImg
          width={65}
          src={props.avatar || img.avatar}
        />
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            marginLeft: 5,
          }}
          className=" text-sm grow text-nowrap"
        >
          <p className=" mx-2 my-0.5 text-wrap">{`用户：${props.username}`}</p>
          <p className=" mx-2 my-0.5">{`会员：${props.usergroupName}`}</p>
          <p className=" mx-2 my-0.5">
            {`剩余：${props.usergroupRemainTime}`}
            {/* {`有效时间：${
              props.usergroupRemainTime === 99999
                ? '永久'
                : props.usergroupRemainTime != null && props.usergroupRemainTime !== 0
                  ? props.usergroupRemainTime + '天'
                  : '已过期'
            }`} */}
          </p>
        </div>
        <div>
          {props.username === 'ROOT' && (
            <Button
              style={{
                display: 'block',
                borderRadius: 20,
                padding: '8px 15px',
                background: '#eee',
                border: '1px solid #aaa',
                boxShadow: '0px 0px 10px #eee',
                margin: '3px',
                minWidth: 90,
              }}
              size="mini"
              onClick={() => {
                navigate('/console');
              }}
            >
              后台管理
            </Button>
          )}
          <Button
            style={{
              display: 'block',
              borderRadius: 20,
              padding: '8px 15px',
              background: '#f66',
              border: '1px solid #aaa',
              boxShadow: '0px 0px 10px #eee',
              margin: '3px',
              marginTop: '5px',
              minWidth: 90,
              color: '#fff',
            }}
            size="mini"
            onClick={useThrottledHandler(() => {
              toggleLoginCertificateVisible(true);
            })}
          >
            登录凭证
          </Button>
          <Button
            style={{
              display: 'block',
              borderRadius: 20,
              padding: '8px 15px',
              background: '#eee',
              border: '1px solid #aaa',
              boxShadow: '0px 0px 10px #eee',
              margin: '3px',
              marginTop: '5px',
              minWidth: 90,
            }}
            size="mini"
            onClick={useThrottledHandler(() => {
              removeItem('user');
              removeItem('group');
              navigate('/one/home');
              Toast.show('已退出登录');
            })}
          >
            安全退出
          </Button>
        </div>
      </div>
      <Modal
        visible={loginCertificateVisible}
        title={
          <div className=" -mt-1 mb-1 text-slate-500">
            <div>请妥善保管哦</div>
            <AiOutlineClose
              className=" absolute top-4 right-3"
              size={20}
              onClick={useThrottledHandler(() => {
                toggleLoginCertificateVisible(false);
              })}
            />
          </div>
        }
        showCloseButton={false}
        closeOnMaskClick={true}
        closeOnAction={true}
        onClose={() => {
          toggleLoginCertificateVisible(false);
        }}
        content={
          <div
            ref={modalRef}
            style={{ height: 500 }}
          >
            <div className=" flex flex-col justify-center items-center gap-5">
              <UserLoginCertificate
                title={'UU天堂'}
                imageUrl={img.loginCredentialsBg}
                username={props.username}
                generateTime={new Date().toLocaleString()}
                width={modalRefSize?.width}
                height={modalRefSize?.height}
              />
            </div>
          </div>
        }
      />
    </>
  );
};

export default UserInfo;
